module.exports = __webpack_public_path__ + "static/img/tabs1.78ecaec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tabs1.png
// module id = X8do
// module chunks = 13